import React, { useEffect, useRef, useState } from 'react';

const AlertError = ({ showError, onClose, children }) => {
    const [dismissed, setDismissed] = useState(false);
    const alertRef = useRef(null);

    useEffect(() => {
        if (showError) {
            setDismissed(false);
        }
    }, [showError, children]);

    const handleClose = () => {
        setDismissed(true);
        if (typeof onClose === 'function') {
            onClose();
        }
    };

    useEffect(() => {
        if (!showError || dismissed) return;

        let listenerActive = false;
        const timer = setTimeout(() => {
            listenerActive = true;
        }, 150);

        const handleClickOutside = (event) => {
            if (!listenerActive) return;
            if (alertRef.current && !alertRef.current.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);

        return () => {
            clearTimeout(timer);
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [showError, dismissed]);

    if (!showError || dismissed) return null;

    return (
        <div
            ref={alertRef}
            role="alert"
            className="alert alert-error fixed z-[9999] top-24 right-4 left-4 sm:left-auto sm:w-auto sm:max-w-xl bg-red-600 border-2 border-red-800 text-white shadow-2xl flex items-start justify-between gap-3 py-3.5 px-4 rounded-xl"
        >
            <div className="flex items-start gap-3 min-w-0 flex-1">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 shrink-0 stroke-current mt-0.5"
                    fill="none"
                    viewBox="0 0 24 24">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div className="flex flex-col min-w-0 flex-1">
                    <span className="text-xs sm:text-sm font-semibold leading-snug break-words">{children}</span>
                    <span className="text-[10px] text-red-100/90 mt-1 font-normal">Click ✕ or click anywhere outside to dismiss</span>
                </div>
            </div>
            <button
                type="button"
                onClick={handleClose}
                aria-label="Close error message"
                title="Close"
                className="btn btn-xs btn-circle bg-red-700 hover:bg-red-900 border-red-400/40 text-white shrink-0 mt-0.5"
            >
                ✕
            </button>
        </div>
    );
};

export default AlertError;
